module.exports = __webpack_public_path__ + "img/right-to-bracket-solid-blue.92a9c74b.svg";